import api from './api';

export interface ExtractValuePropsInput {
  materials?: string;
  url?: string;
  product?: string;
  companyName?: string;
}

export interface ValuePropItem {
  valueProp: string;
  type: string;
  evidence: string;
  bestFor: string;
  useWhen: string;
  tier: number;
}

export interface ValuePropInventory {
  companyName: string;
  primaryValueProp: string;
  audience: string;
  valueProps: ValuePropItem[];
  byChannel: {
    emailSubjects: string[];
    emailOpener: string;
    linkedinMessage: string;
  };
  summary: string;
}

export interface ExtractResult {
  inventory: ValuePropInventory | null;
  raw?: string;
  provider: string;
  model: string;
}

class ValuePropService {
  async extract(input: ExtractValuePropsInput): Promise<ExtractResult> {
    const response = await api.post('/value-props/extract', input);
    return response.data;
  }
}

const valuePropService = new ValuePropService();
export default valuePropService;
